import React from "react";
import { FormGroup } from "react-bootstrap";
import { Col, FormLabel, Row, Tab, Tabs } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import ButtonBar from "../../../../core/ButtonBar";
import ComponentHeader from "../../../../core/ComponentHeader/ComponentHeader";
import SubmitControl from "../../../../core/SubmitControl";
import Table from "../../../../core/Table";

const IndividualDetail = props => {
  const individual = props.individual;

  const roles = (
    <div>
      <div className="table-buttons-container">
        <div></div>
        <Table
          node={props.node}
          data={props.data}
          columns={props.columns}
          paginationOptions={props.paginationOptions}
          onTableChange={props.onTableChange}
          onRowClick={props.onRowClick}
          selectRow={props.selectRow}
          showTableHeader
          tableLabel={labels.partyRoles}
          onDeleteRow={props.handleOnDelete}
          onCreateRow={props.handleAddNew}
          pageInfo={props.pageInfo}
          sortInfo={props.sortInfo}
        />
      </div>
    </div>
  );

  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <ComponentHeader
          title={labels.individual}
          id={individual?.id}
          showBackButton
        />
        <div className="bordered_bottom_rounded">
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.name}</FormLabel>
            </Col>
            <Col sm="6">
              <FormLabel>{individual?.name}</FormLabel>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.email}</FormLabel>
            </Col>
            <Col sm="6">
              <FormLabel>{individual?.email}</FormLabel>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.dateFromTo}</FormLabel>
            </Col>
            <Col sm="6">
              <FormGroup controlId="dateFromTo">
                <SubmitControl
                  type="dateRange"
                  placeholder={[
                    labels.dateFromPlaceholder,
                    labels.dateToPlaceholder
                  ]}
                  validationRule={props.validationRules?.dateFromTo}
                  value={individual?.dateFromTo}
                  onChange={props.onChange}
                  controlId={"dateFromTo"}
                />
              </FormGroup>
            </Col>
          </Row>

          <Tabs
            id="individual_tabs"
            className="Tabs"
            mountOnEnter
            unmountOnExit
          >
            <Tab
              eventKey="partyRoles"
              title={labels.partyRoles}
              className="Tab"
            >
              {roles}
            </Tab>
          </Tabs>

          <ButtonBar
            onSave={props.onSave}
            disabled={props.disabled}
            partyId={props.partyId}
          />
        </div>
      </div>
    </div>
  );
};

export default IndividualDetail;
